(function () {
  const initLovedEssentials = () => {
    document.querySelectorAll("[data-loved-essentials-slider]").forEach((slider) => {
      if (slider.classList.contains("loved-essentials--initialized")) {
        return;
      }

      if (typeof Swiper === "undefined") {
        return;
      }

      const section = slider.closest(".loved-essentials");
      if (!section) {
        return;
      }

      slider.classList.add("loved-essentials--initialized");

      const desktopSlides = parseFloat(slider.dataset.slidesDesktop || "2");
      const mobileSlides = parseFloat(slider.dataset.slidesMobile || "1.2");

      new Swiper(slider, {
        slidesPerView: mobileSlides,
        spaceBetween: 14,
        slidesOffsetAfter: 20,
        watchOverflow: true,
        keyboard: {
          enabled: true,
        },
        navigation: {
          prevEl: section.querySelector(".loved-essentials__arrow--prev"),
          nextEl: section.querySelector(".loved-essentials__arrow--next"),
        },
        breakpoints: {
          750: {
            slidesPerView: desktopSlides,
            spaceBetween: 18,
            slidesOffsetAfter: 0,
          },
        },
      });
    });
  };

  document.addEventListener("DOMContentLoaded", initLovedEssentials);
  document.addEventListener("shopify:section:load", initLovedEssentials);
})();
